import React, { useState, memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useCancelShiftMutation } from '../../../../redux/externalAgencyShifts';

import './CancelShiftModal.css';
import { rateTemplate, shiftTypeTemplate, timePeriodTemplate } from '../agency-utils';
import utils from '../../../../utils/utils';
import LoadingSpinner from '../../../../components/spinner/LoadingSpinner';

const CancelShiftModal = ({ shift = null, onCancel = () => {}, onComplete, showNotification }) => {
	const [cancelShift] = useCancelShiftMutation();
	const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);

	let handleCancelShift;
	if (shift) {
		handleCancelShift = async () => {
			setShowLoadingSpinner(true);
			try {
				await cancelShift({
					slotId: shift.id,
					caregiverId: shift.professional_id,
					callOutReason: null,
					action: null
				}).unwrap();
				setTimeout(() => {
					showNotification('info', `${shift.professional} has been successfully removed from the shift.`);
				}, 1600);
				onComplete({ ...shift });
			} catch (error) {
				let message = 'Sorry, there was an error trying to cancel this shift. Please try again.';
				if (typeof error.data?.errors?.[0]?.message === 'string') {
					message = error.data?.errors?.[0]?.message;
				}
				showNotification('error', message);
				onComplete({ ...shift, error: true, errorField: error.data?.errors?.[0]?.field });
			}
		};
	}

	return (
		<Modal size="lg" show className="cancel-shift-modal no-gutters" onHide={onCancel} backdrop="static">
			<Modal.Header closeButton>
				<Modal.Title>
					<b>Cancel shift for this professional?</b>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="cancel-shift-container">
					<section className="shift-details-container modal-assign-professionals">
						<div className="shift-details-body">
							<div className="shift-details-row">
								<div className="shift-details-row-div col-50">
									<p className="shift-details-title">Facility</p>
									<p className="shift-details-text">{shift.facility_name}</p>
								</div>
								<div className="shift-details-row-div col-50">
									<p className="shift-details-title">Shift type</p>
									<div className="shift-details-text">{shiftTypeTemplate(shift)}</div>
								</div>
							</div>
							<div className="shift-details-row">
								<div className="shift-details-row-div col-50">
									<p className="shift-details-title">Professional assigned</p>
									<div className="shift-details-text">{shift.professional}</div>
								</div>
								<div className="shift-details-row-div col-25">
									<p className="shift-details-title">Rate</p>
									<div className="shift-details-text">
										{rateTemplate(shift)}
										<br />
										<em>({utils.formatMoney(shift.estimated_pay)} estimate)</em>
									</div>
								</div>
								<div className="shift-details-row-div col-25">
									<p className="shift-details-title">Time</p>
									<div className="shift-details-text">{timePeriodTemplate(shift)}</div>
								</div>
							</div>
						</div>
					</section>
					{showLoadingSpinner && <LoadingSpinner />}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onCancel} variant="tertiary" disabled={false}>
					Keep shift
				</Button>
				<Button variant="primary" className="no-gutters" onClick={handleCancelShift}>
					Cancel shift
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default memo(CancelShiftModal);
